import useOnlineState from 'beautiful-react-hooks/useOnlineState';
import React, { FC, PropsWithChildren, useContext, useMemo } from 'react';

export const Context = React.createContext<AppContextReturnTypes>({
  isOnline: true,
});

interface AppContextProps {}
type AppContextReturnTypes = {
  isOnline: boolean;
};

export const AppContext: FC<PropsWithChildren<AppContextProps>> = ({
  children,
}) => {
  const isOnline = useOnlineState();

  const appState = useMemo(() => ({ isOnline }), [isOnline]);

  return <Context.Provider value={appState}>{children}</Context.Provider>;
};

export const useAppContext = () => useContext(Context);
